import AuthorizedLayout from '../layouts/AuthorizedLayout';
import NotAuthorizedLayout from '../layouts/NotAuthorizedLayout';
import AnnouncementList from '../views/Announcement/AnnouncementList';
import AttendanceTracking from '../views/AttendanceTracking/AttendanceTracking';
import ChangePassword from '../views/changePassword/ChangePassword';
import ClassAttendance from '../views/classAttendance/ClassAttendance';
import ClassesBook from '../views/classesBook';
import ClassesBookClasses from '../views/classesBook/classes';
import ClassesHistory from '../views/classesHistory/ClassesHistory';
import ClassTeacherAttendance from '../views/classesTeacherAttendance';
import Courses from '../views/courses';
import CourseDetails from '../views/courses/CourseDetails';
import GradeEntryCreateEvaluation from '../views/GradeEntry/GradeEntryCreateEvaluation';
import GradeEntryList from '../views/GradeEntry/GradeEntryList';
import AddEvaluationGradeEntry from '../views/GradeEntry/parts/AddEvaluationGrade/AddEvaluationGradeEntry';
import GradeReplacementPetitions from '../views/GradeReplacementPetitions';
import LearningResultAssociate from '../views/LearningResult/associate';
import LearningResultList from '../views/LearningResult/list';
import Login from '../views/login/Login';
import PeriodEnd from '../views/periodEnd/PeriodEnd';
import PeriodEndReview from '../views/periodEndReview/PeriodEndReview';
import Reports from '../views/reports/Reports';
import StartClasses from '../views/startClasses/StartClasses';
import StudentFile from '../views/studentFile/studentFileList';
import UpdateStudentFile from '../views/studentFile/updateStudentFile';
import TeacherSchedule from '../views/teacherSchedule/TeacherSchedule';
import UntrackedAttendance from '../views/untrackedAttendance/UntrackedAttendance';

export enum PathsLayouts {
  auth = '/auth',
  announcements = '/announcements',
  classes = '/classes',
  gradeEntry = '/grade-entry',
  reports = '/reports',
  periodEnd = '/period-end',
  learningResult = '/learning-result',
  classesBook = '/classes-book',
  courses = '/courses',
  gradeReplacementPetitions = '/grade-replacement-petitions',
  studentFile = '/student-file',
  studentPetitions = '/student-petitions',
}

export type ViewRouteType = {
  path: string;
  component: () => JSX.Element;
};

export type RoutesByLayout = {
  [key in PathsLayouts]: {
    layoutComponent: () => JSX.Element;
    defaultPath: string;
    views: ViewRouteType[];
  };
};

/**
 * Contiene todos los layouts con sus vistas
 */
const routes: RoutesByLayout = {
  [PathsLayouts.auth]: {
    layoutComponent: NotAuthorizedLayout,
    defaultPath: '/',
    views: [
      {
        path: '/',
        component: Login,
      },
      {
        path: '/activate-account',
        component: ChangePassword,
      },
      {
        path: '/reset-password',
        component: ChangePassword,
      },
    ],
  },
  [PathsLayouts.classes]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/start',
    views: [
      {
        path: '/start',
        component: StartClasses,
      },
      {
        path: '/:id/attendance',
        component: ClassAttendance,
      },
      {
        path: '/history',
        component: ClassesHistory,
      },
      {
        path: '/untracked-attendance',
        component: UntrackedAttendance,
      },
      {
        path: '/tracking',
        component: AttendanceTracking,
      },
      {
        path: '/schedule',
        component: TeacherSchedule,
      },
      {
        path: '/teacher-attendance',
        component: ClassTeacherAttendance,
      },
    ],
  },
  [PathsLayouts.gradeEntry]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/list',
    views: [
      {
        path: '/list',
        component: GradeEntryList,
      },
      {
        path: '/:id/create-evaluation',
        component: GradeEntryCreateEvaluation,
      },
      {
        path: '/:id/add-evaluation',
        component: AddEvaluationGradeEntry,
      },
    ],
  },
  [PathsLayouts.gradeReplacementPetitions]: {
    defaultPath: '/pending',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/pending',
        component: GradeReplacementPetitions,
      },
      {
        path: '/completed',
        component: GradeReplacementPetitions,
      },
    ],
  },
  [PathsLayouts.reports]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: Reports,
      },
    ],
  },
  [PathsLayouts.periodEnd]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: PeriodEnd,
      },
      {
        path: '/:id',
        component: PeriodEndReview,
      },
    ],
  },
  [PathsLayouts.learningResult]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: LearningResultList,
      },
      {
        path: '/:sectionId',
        component: LearningResultAssociate,
      },
    ],
  },
  [PathsLayouts.classesBook]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: ClassesBook,
      },
      {
        path: '/:sectionId',
        component: ClassesBookClasses,
      },
    ],
  },
  [PathsLayouts.courses]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: Courses,
      },
      {
        path: '/:id',
        component: CourseDetails,
      },
    ],
  },
  [PathsLayouts.studentFile]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: StudentFile,
      },
      {
        path: '/update/:studentId',
        component: UpdateStudentFile,
      },
    ],
  },
  [PathsLayouts.studentPetitions]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: UpdateStudentFile,
      },
    ],
  },
  [PathsLayouts.announcements]: {
    defaultPath: '/',
    layoutComponent: AuthorizedLayout,
    views: [
      {
        path: '/',
        component: AnnouncementList,
      },
    ],
  },
};

export default routes;
